exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-email[data-v-6693c120]{display:inline-block;padding:0 5px;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;background:#fff;border:1px solid;border-radius:10px;border-color:#ebebeb}.badge-email[data-v-6693c120]:hover{background-color:#f7f7f7}.invalid[data-v-6693c120]{border-color:red}.close[data-v-6693c120]:focus,.close[data-v-6693c120]:hover{text-decoration:none;opacity:.75}.close[data-v-6693c120]{float:right;font-size:1rem;color:#c5c4c4;opacity:1;margin:3px 5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6693c120","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/input-email-list.vue
// module id = 1145
// module chunks = 0